/**
 * Phaserゲーム エントリーポイント
 * ゲームの初期化と破棄を管理
 */
import Phaser from 'phaser';
import { phaserConfig } from './config/PhaserConfig';

let gameInstance: Phaser.Game | null = null;
let resizeHandler: (() => void) | null = null;

function syncInputBounds(game: Phaser.Game): void {
  game.scale.updateBounds();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const inputManager = game.input as any;
  if (inputManager?.updateBounds) {
    inputManager.updateBounds();
  }
}

/**
 * Phaserゲームを作成
 * @param container - ゲームを埋め込むHTML要素
 * @returns Phaserゲームインスタンス
 */
export function createPhaserGame(container: HTMLElement): Phaser.Game {
  // 既存のインスタンスがあれば破棄
  if (gameInstance) {
    destroyPhaserGame();
  }

  // コンテナIDを設定に反映
  const config: Phaser.Types.Core.GameConfig = {
    ...phaserConfig,
    parent: container,
  };

  gameInstance = new Phaser.Game(config);

  // 初期レイアウト確定後に入力境界を同期
  gameInstance.events.once('ready', () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (gameInstance) {
          syncInputBounds(gameInstance);
        }
      });
    });
  });

  // ウィンドウリサイズ時にも境界を更新
  resizeHandler = () => {
    if (gameInstance) {
      syncInputBounds(gameInstance);
    }
  };
  window.addEventListener('resize', resizeHandler);

  return gameInstance;
}

/**
 * Phaserゲームを破棄
 */
export function destroyPhaserGame(): void {
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler);
    resizeHandler = null;
  }

  if (gameInstance) {
    gameInstance.destroy(true);
    gameInstance = null;
  }
}

/**
 * 現在のゲームインスタンスを取得
 */
export function getGameInstance(): Phaser.Game | null {
  return gameInstance;
}

// シーンのエクスポート
export { PreloadScene } from './scenes/PreloadScene';
export { MainGameScene } from './scenes/MainGameScene';
